import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/publish.svg
 */
const IconPublish: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M22.612.068H1.362a1.341 1.341 0 00-.964.403A1.38 1.38 0 000 1.45v19.163a1.394 1.394 0 00.397.98 1.358 1.358 0 00.965.402h7.546a.29.29 0 00.284-.187.3.3 0 00.02-.12v-1.176a.3.3 0 00-.186-.287.288.288 0 00-.118-.02H1.766V7.18h20.442v13.024h-7.116a.29.29 0 00-.304.307v1.177a.301.301 0 00.086.22.291.291 0 00.218.086h7.544a1.34 1.34 0 00.966-.402 1.381 1.381 0 00.398-.98V1.475a1.429 1.429 0 00-.41-.99 1.393 1.393 0 00-.978-.417zm-.404 5.321H1.766V1.86h20.442v3.53z"
      fill="currentColor"
    />
    <path
      d="M3.583 4.443a.813.813 0 00.807-.819.813.813 0 00-.807-.818.813.813 0 00-.808.818c0 .453.362.82.808.82zM5.93 4.443a.813.813 0 00.808-.819.813.813 0 00-.808-.818.813.813 0 00-.807.818c0 .453.361.82.807.82zM8.253 4.443a.813.813 0 00.808-.819.813.813 0 00-.808-.818.813.813 0 00-.807.818c0 .453.361.82.807.82zM14.864 15.114a.869.869 0 00.58.256.755.755 0 00.58-.256.817.817 0 00.247-.589.828.828 0 00-.247-.588l-3.457-3.505a.807.807 0 00-.58-.25.795.795 0 00-.58.25l-3.458 3.505a.838.838 0 000 1.177.815.815 0 001.16 0l2.044-2.073v10.183a.85.85 0 00.244.597.828.828 0 001.179 0 .85.85 0 00.244-.598V13.043l2.043 2.072z"
      fill="currentColor"
    />
  </svg>
);

export default IconPublish;
